export default [
    {
        component: () => import(/* webpackChunkName: 'farmacia-fila-atendimento' */ '@/views/farmacia/fila-atendimento/Index'),
        path: 'fila-atendimento',
        redirect: 'fila-atendimento/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'farmacia-fila-atendimento' */'@/views/farmacia/fila-atendimento/List.vue'),
                name: 'farmacia-fila-atendimento-index',
                path: 'index',
            },
        ],
    },
]